.form-subtitle {
  margin-top: calc(var(--spacer) * 3.5);
  margin-bottom: calc(var(--spacer) * 2.5);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

gz-labeled-content {
  margin-top: calc(var(--spacer) * 1.5);
}

.window-summary {
  width: 550px;
  min-height: 240px;
  padding: calc(var(--spacer) * 3);
  margin: var(--spacer) 0;
  box-shadow: none;
  border: 1px solid var(--chart-101-pressed-dividers);
  border-radius: 5px;
}
